/** HTTP status codes that warrant a retry; everything else (other 4xx) is terminal. */
const RETRYABLE_STATUS_CODES: readonly number[] = [408, 429, 500, 502, 503, 504];

/**
 * Decides whether a failed telemetry send should be retried by the agent.
 * Network / no-status failures (`null`) are retryable; otherwise only the
 * transient HTTP statuses in `RETRYABLE_STATUS_CODES` are.
 * @param status - The HTTP status code, or `null` for a network/no-status error.
 */
export const isRetryableTelemetryStatus = (status: number | null): boolean => {
  if (status === null) return true;
  return RETRYABLE_STATUS_CODES.includes(status);
};
